import * as Tgcc from '../tgccGlobal';
import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import { CSSProperties } from 'react';
import { connect } from 'react-redux';

const wrapperStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: '0 5px 5px 5px',
    boxShadow: Tgcc.Styles.boxShadow,
    fontSize: '8px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    margin: '5px',
    height: '310px',
    transition: 'transform 250ms',
    ':hover': {
        transform: 'translateY(-10px)'
    },
    '@media (max-width:800px) and (max-height:1280px)': {
        margin: '10px auto'
    },
    '@media (max-width:768px) and (max-height:1366px)': {
        margin: '10px auto'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        margin: '10px auto'
    },
    '@media (max-width:414px)': {
        margin: 'auto auto 10px auto'
    }
};

const designationStyle: CSSProperties = {
    alignSelf: 'flex-start',
    color: '#606060',
    fontSize: '18px',
    fontFamily: 'Lulo'
};

const logoTextStyle: CSSProperties = {
    alignSelf: 'center',
    height: '20px',
    lineHeight: '20px',
    margin: '5px',
    fontSize: '10px',
    letterSpacing: '3px',
    display: 'none'
};
const contentStyle: CSSProperties = {
    position: 'relative',
    height: '240px',
    width: '275px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
};
const styleStyle: CSSProperties = {
    alignSelf: 'flex-start',
    fontSize: '16px',
    letterSpacing: '3px',
    maxWidth: '100%',
    color: '#606060'
};
const styleNoPicStyle: CSSProperties = {
    alignSelf: 'center',
    height: '40px',
    fontSize: '24px',
    lineHeight: '40px',
    letterSpacing: '5px'
};
const imageStyle: CSSProperties = {
    alignSelf: 'center',
    maxWidth: '80%',
    maxHeight: '70%',
    cursor: 'pointer'
};
const descStyle: CSSProperties = {
    alignSelf: 'flex-start',
    color: '#606060',
    fontSize: '11px'
};

const brandStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center'
};
const colorCountStyle: CSSProperties = {
    fontSize: '11px'
};

class CardProps {
    product: Tgcc.Product;
    brand: Tgcc.ProductBrand;
    onSelect?: (product: Tgcc.Product) => void;
    onClick?: () => void;
    brandFont?: string;
    descFont?: string;
}

class _RealCampusProductCard extends React.Component<CardProps, any> {
    state = {
        processedImageSrc: null
    };

    componentWillMount() {
        if (this.props.brandFont) {
            brandStyle.fontFamily = this.props.brandFont;
            styleStyle.fontFamily = this.props.brandFont;
        }
        if (this.props.descFont) {
            descStyle.fontFamily = this.props.descFont;
        }
    }

    handleSelection = (evt) => {
        if (this.props.onSelect) {
            this.props.onSelect(this.props.product);
        }
        if (this.props.onClick) {
            this.props.onClick();
        }
    };

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    };

    handleMissingLogo = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.style.display = 'none';
        var el: HTMLElement = event.currentTarget.nextSibling as HTMLElement;
        if (el && el.attributes['style']) {
            let style = el.attributes['style'].value.replace('display: none;', 'display: flex;');
            el.attributes['style'].value = style;
        }
    };

    getBrandImgStyle() {
        var style: CSSProperties = {
            width: '175px'
        };
        switch (this.props.product.brand) {
            case 'Hanes':
                style.width = '60px';
                return style;
            case 'Port and Company':
                style.width = '110px';
                return style;
            case 'A4':
                style.width = '65px';
                return style;
            case 'Baw':
                style.width = '110px';
                return style;
            case 'Vantage':
                style.width = '85px';
                return style;
            case 'Vineyard Vines':
                style.width = '125px';
                return style;
            case 'District':
                style.width = '60px';
                return style;
            default:
                return style;
        }
    }

    getDesignation = () => {
        if (this.props.product.designation) {
            return <div style={designationStyle}>{this.props.product.designation}</div>;
        }
        return <div style={designationStyle}>&nbsp;</div>;
    };

    handleImageLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
        const img = event.currentTarget as HTMLImageElement;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
    
        if (!ctx) return;
    
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
    
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const { data, width, height } = imageData;
    
        // Detect non-white boundaries
        let minX = width, minY = height, maxX = 0, maxY = 0;
        const isWhite = (r: number, g: number, b: number) => r > 240 && g > 240 && b > 240;
    
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                const index = (y * width + x) * 4;
                const [r, g, b] = [data[index], data[index + 1], data[index + 2]];
                if (!isWhite(r, g, b)) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
        }
    
        // If the entire image is white, retain the original image
        if (minX === width || minY === height || maxX === 0 || maxY === 0) {
            this.setState({ processedImageSrc: null });
            return;
        }
    
        // Calculate trimmed dimensions
        const trimWidth = maxX - minX + 1;
        const trimHeight = maxY - minY + 1;
    
        // Create a new canvas with the trimmed dimensions
        const trimmedCanvas = document.createElement('canvas');
        const trimmedCtx = trimmedCanvas.getContext('2d');
        trimmedCanvas.width = trimWidth;
        trimmedCanvas.height = trimHeight;
        if (trimmedCtx) {
            trimmedCtx.drawImage(canvas, minX, minY, trimWidth, trimHeight, 0, 0, trimWidth, trimHeight);
        }
    
        // Convert the trimmed canvas to a data URL and set it as the image source
        const trimmedImageSrc = trimmedCanvas.toDataURL();
        
        // Update state and log the result after the state is updated
        this.setState({ processedImageSrc: trimmedImageSrc }, () => {
            console.log('Processed Image Source:', this.state.processedImageSrc);
        });
    };
    

    componentDidUpdate(prevProps: CardProps) {
        if (prevProps.product !== this.props.product) {
            // Reset processedImageSrc when the product changes
            this.setState({ processedImageSrc: null });
        }
    }

    render() {
        let cardImage = this.props.product.thumbnail;
        let cardStyle = this.props.product.style;
        let description = this.props.product.description;
        let colorCount = this.props.product.colorCount;
        let designation = this.getDesignation();
        
        // Conditionally use the processed image source if available
        const imageSrc = this.state.processedImageSrc 
            ? this.state.processedImageSrc 
            : Tgcc.getProductPath(cardImage.replace(' ', '%20')) + `?v=${this.props.product.brand + this.props.product.style || ''}`;
    
        return (
            <div style={wrapperStyle}>
                <div style={brandStyle}>
                    {this.props.product.brand === 'Outer Banks'
                        ? <span style={{ fontFamily: 'BarlowLight', fontSize: '22px', letterSpacing: '5px', textTransform: 'uppercase', color: '#222', fontWeight: 600, display: 'block', textAlign: 'center', lineHeight: '20px' }}>Outer Banks</span>
                        : <img style={this.getBrandImgStyle()} src={Tgcc.getBrandPath(this.props.brand.image)} />
                    }
                </div>
                <div style={contentStyle} onClick={this.handleSelection}>
                    {cardImage && (
                        <img
                            key={`${this.props.product.brand}-${this.props.product.style}`} // Unique key based on product attributes
                            style={imageStyle}
                            src={imageSrc}  // Use the processed image or fallback to the original
                            onError={this.handleImageError}
                            onLoad={this.handleImageLoad}
                            crossOrigin="anonymous"
                        />
                    )}
    
                    <div>
                        {designation}
                        <div style={styleStyle}>{cardStyle}</div>
                        <div style={descStyle}>{description}</div>
                        <div style={colorCountStyle}>Colors: {colorCount}</div>
                    </div>
                </div>
            </div>
        );
    }
    
    
}
export var RealCampusProductCard = Radium(_RealCampusProductCard);